import { createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "./createBreakpoints";
const BREAKPOINTS = {
  xs: 0,
  s: 375,
  sm: 600,
  md: 768,
  lm: 1024,
  lg: 1440,
  xl: 1920,
};

const breakpointsFull = {
  breakpoints: createBreakpoints({
    values: BREAKPOINTS,
  }),
};

const defaultTheme = createMuiTheme({
  breakpoints: breakpointsFull.breakpoints,
});

const theme = createMuiTheme({
  breakpoints: breakpointsFull.breakpoints,
  palette: {
    primary: {
      main: "rgb(77, 122, 40)",
    },
    secondary: {
      main: "rgb(220, 223, 212)",
    },
  },
  typography: {
    fontFamily: "'Yu Gothic', sans-serif",
    p: {
      fontSize: "1rem",
    },
    h1: {
      fontSize: "3rem",
      fontWeight: "bold",
      letterSpacing: "2.57px",
      //one up for max width lm goes up to 1439 -1 from lg
      [defaultTheme.breakpoints.between("md", "lm")]: {
        fontSize: "2.25rem",
        letterSpacing: "1.93px",
      },
      [defaultTheme.breakpoints.between("xs", "sm")]: {
        fontSize: "1.5rem",
        letterSpacing: "1.28px",
      },
    },
    h2: {
      fontWeight: "bold",
      fontSize: "1.5rem",
      letterSpacing: "1.28px",
      [defaultTheme.breakpoints.between("md", "lm")]: {
        fontSize: "1.125rem",
        letterSpacing: ".96px",
      },
      [defaultTheme.breakpoints.between("xs", "sm")]: {
        fontSize: "1.5rem",
        letterSpacing: "1.28px",
      },
    },
    h3: {
      fontWeight: "bold",
      fontSize: "1.3125rem",
      letterSpacing: "1.12px",
      [defaultTheme.breakpoints.between("md", "lm")]: {
        fontSize: "1.125rem",
        letterSpacing: ".96px",
      },
      [defaultTheme.breakpoints.between("xs", "sm")]: {
        fontSize: "1.5rem",
        letterSpacing: "1.28px",
      },
    },

    body1: { fontWeight: 500 },
  },
});

export default theme;
